import { useCallback } from 'react';
import { DailyLedger } from '../modules/vendor/pages/dailyLedger/types/dailyLedger';

export const useVendorLedgerBalanceCalculator = () => {
  const calculateRunningBalance = useCallback((ledgers:DailyLedger[]) => {
    if (!ledgers || !Array.isArray(ledgers)) return [];
    
    let runningBalance = 0;
    
    return ledgers.map((ledger, index) => {
      const credit = ledger.credit || 0;
      const debit = ledger.debit || 0;
      
      // Balance = Previous Balance + Debit - Credit
      runningBalance = runningBalance + credit - debit;
      
      return {
        ...ledger,
        balance: runningBalance
      };
    });
  }, []);

  return { calculateRunningBalance };
};